var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.response.title")) + " ")]), _c('v-card-subtitle', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.response.subtitle")) + " ")]), _vm.value.date ? _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("thg.PriceTable.to", {
    date: _vm.simpleDoubleDigitDate(_vm.value.date)
  })) + " ")]) : _vm._e()], 1), !_vm.value.isCompleted ? _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "info",
      "elevation": 0
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.response.makeOffer")) + " ")])], 1) : _vm._e()], 1), _vm.value.history && _vm.value.history.length > 0 ? _c('repair-estimate-request-response-card-history', {
    attrs: {
      "value": _vm.value
    }
  }) : _vm._e(), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "title": _vm.$t('repairEstimateRequest.response.makeOffer'),
      "subtitle": _vm.$t('repairEstimateRequest.response.makeOfferSubtitle'),
      "loading": _vm.loading,
      "rightLoading": _vm.loading,
      "rightDisabled": !_vm.isValid,
      "hideRight": _vm.hideRight,
      "leftText": _vm.leftText,
      "rightText": _vm.rightText
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-window', {
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.CreateInvoiceWindow.FILE
    }
  }, [_c('v-radio-group', {
    model: {
      value: _vm.response,
      callback: function callback($$v) {
        _vm.response = $$v;
      },
      expression: "response"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('repairEstimateRequest.response.makeOffer'),
      "value": _vm.ResponseType.ACCEPT
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('repairEstimateRequest.response.requestMore'),
      "value": _vm.ResponseType.REQUEST
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('repairEstimateRequest.response.reject'),
      "value": _vm.ResponseType.REJECT
    }
  })], 1), _vm.response === _vm.ResponseType.ACCEPT ? _c('drop-area-multi', {
    staticClass: "my-2",
    attrs: {
      "files": _vm.files,
      "text": _vm.$t('cost.dragAndDropDocuments'),
      "dragoverText": _vm.$t('sign.SignDocumentCreateDialog.title'),
      "loading": _vm.loading,
      "accept": ".pdf",
      "maxFiles": 1
    },
    on: {
      "update:files": function updateFiles($event) {
        _vm.files = $event;
      }
    }
  }) : _vm._e(), _vm.response === _vm.ResponseType.REQUEST ? _c('v-textarea', {
    attrs: {
      "label": _vm.$t('repairEstimateRequest.response.requestMoreReason'),
      "hint": _vm.$t('repairEstimateRequest.response.requestMoreReasonHint'),
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.requestMoreDataReason,
      callback: function callback($$v) {
        _vm.requestMoreDataReason = $$v;
      },
      expression: "requestMoreDataReason"
    }
  }) : _vm._e(), _vm.response === _vm.ResponseType.REJECT ? _c('v-textarea', {
    attrs: {
      "label": _vm.$t('repairEstimateRequest.response.rejectReason'),
      "hint": _vm.$t('repairEstimateRequest.response.rejectReasonHint'),
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.rejectReason,
      callback: function callback($$v) {
        _vm.rejectReason = $$v;
      },
      expression: "rejectReason"
    }
  }) : _vm._e()], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.CreateInvoiceWindow.FIELDS
    }
  }, [_c('v-row', {
    staticClass: "pt-1",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('v-text-field', {
    ref: "startField",
    attrs: {
      "label": _vm.$t('objects.repairEstimateRequest.number'),
      "hint": _vm.$t('objects.repairEstimateRequest.numberHint'),
      "persistent-hint": true,
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.valueCopy.number,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "number", $$v);
      },
      expression: "valueCopy.number"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "py-4",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("components.RepairEstimateRequestResponseCard.text")) + " ")])])], 1), _vm._l(_vm.valueCopy.lineItems, function (lineItem, index) {
    return _c('v-row', {
      key: 'li' + index,
      attrs: {
        "dense": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": index > 0 ? 10 : 12,
        "md": "6"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": _vm.$t('objects.invoiceLine.title') + ' *',
        "outlined": "",
        "hide-details": "",
        "dense": "",
        "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
      },
      model: {
        value: lineItem.title,
        callback: function callback($$v) {
          _vm.$set(lineItem, "title", $$v);
        },
        expression: "lineItem.title"
      }
    })], 1), index > 0 ? _c('v-col', {
      staticClass: "d-flex d-sm-none",
      attrs: {
        "cols": "2"
      }
    }, [_c('tooltip', {
      attrs: {
        "text": _vm.$t('remove')
      }
    }, [index > 0 ? _c('v-btn', {
      staticClass: "pa-6",
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.removeInvoiceLine(index);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-delete")])], 1) : _vm._e()], 1)], 1) : _vm._e(), _c('v-col', {
      attrs: {
        "cols": "9",
        "md": "3"
      }
    }, [_c('v-text-field', {
      staticClass: "text-right",
      attrs: {
        "label": _vm.$t('objects.invoiceLine.amount') + ' *',
        "outlined": "",
        "hide-details": "",
        "dense": "",
        "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
      },
      model: {
        value: lineItem.amount,
        callback: function callback($$v) {
          _vm.$set(lineItem, "amount", _vm._n($$v));
        },
        expression: "lineItem.amount"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "3",
        "md": "2"
      }
    }, [_c('v-text-field', {
      staticClass: "text-right",
      attrs: {
        "label": _vm.$t('objects.invoiceLine.taxRate') + ' *',
        "outlined": "",
        "hide-details": "",
        "dense": "",
        "step": 1,
        "min": 0,
        "max": 100,
        "type": "number",
        "suffix": "%",
        "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
      },
      model: {
        value: lineItem.taxRate,
        callback: function callback($$v) {
          _vm.$set(lineItem, "taxRate", _vm._n($$v));
        },
        expression: "lineItem.taxRate"
      }
    })], 1), index > 0 ? _c('v-col', {
      staticClass: "d-none d-sm-flex",
      attrs: {
        "cols": "1",
        "md": "1"
      }
    }, [_c('tooltip', {
      attrs: {
        "text": _vm.$t('remove')
      }
    }, [index > 0 ? _c('v-btn', {
      staticClass: "mt-1 pa-2",
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.removeInvoiceLine(index);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-delete")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1);
  }), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.addInvoiceLine
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("invoice.addPosition")) + " ")], 1), _c('v-divider', {
    staticClass: "mt-6"
  }), _c('v-row', {
    staticClass: "pt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-simple-table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.subTotal")) + " ")]), _c('td', {
    staticClass: "text-end",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.valueCopy.totalNet, _vm.valueCopy.currency)) + " ")])])]), _vm._l(_vm.valueCopy.taxRates, function (taxRate) {
    return _c('tr', {
      key: 'taxRate' + taxRate
    }, [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }), _c('td', {
      staticStyle: {
        "min-width": "150px"
      },
      attrs: {
        "colspan": "1"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.taxRate")) + " " + _vm._s(taxRate) + " "), _c('span', [_vm._v("%")])])]), _c('td', {
      staticClass: "text-end",
      attrs: {
        "colspan": "1"
      }
    }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.valueCopy.calcItemsPerTaxRate(taxRate), _vm.valueCopy.currency)) + " ")])]);
  }), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.total")) + " ")]), _c('td', {
    staticClass: "text-end",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.valueCopy.totalGross, _vm.valueCopy.currency)) + " ")])])])], 2)], 1)], 1)], 2)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }